export const GF_USER_MANUAL = process.env.REACT_APP_GF_USER_MANUAL;
export const AF_USER_MANUAL = process.env.REACT_APP_AF_USER_MANUAL;
export const FO_USER_MANUAL = process.env.REACT_APP_FO_USER_MANUAL;
export const FO_BDR_MANUAL = process.env.REACT_APP_FO_BDR_MANUAL;
